var _circle, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTumer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 77,
    r: 44,
    stroke: "url(#paint0_linear_6400_28121)",
    strokeWidth: 11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 77L66 60.5",
    stroke: "url(#paint1_linear_6400_28121)",
    strokeWidth: 11,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.25 41.25L104.5 33",
    stroke: "url(#paint2_linear_6400_28121)",
    strokeWidth: 11,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3748 13.0382C56.0015 12.4535 57.3825 11.9368 59.3036 11.5683C61.2247 11.1998 63.5785 11 66 11C68.4215 11 70.7753 11.1998 72.6964 11.5683C74.6175 11.9368 75.9985 12.4535 76.6252 13.0382",
    stroke: "url(#paint3_linear_6400_28121)",
    strokeWidth: 11,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6400_28121",
    x1: 110,
    y1: 33,
    x2: 7.25588,
    y2: 97.5214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE1E2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6400_28121",
    x1: 67,
    y1: 60.5,
    x2: 65.3744,
    y2: 60.5619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE1E2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6400_28121",
    x1: 104.5,
    y1: 33,
    x2: 94.8677,
    y2: 39.0489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE1E2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6400_28121",
    x1: 55,
    y1: 11,
    x2: 59.8997,
    y2: 23.3077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE1E2D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTumer);
export default __webpack_public_path__ + "static/media/Tumer.7f6308215704ca2a2ef8177952e7aa69.svg";
export { ForwardRef as ReactComponent };